var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1735 38.9656C44.4154 40.7134 43.5226 42.3223 42.4865 43.8005C41.0714 45.8179 39.9174 47.2119 39.0246 47.9869C37.6432 49.2588 36.1607 49.9116 34.5729 49.9453C33.4358 49.9453 32.0586 49.621 30.4624 48.964C28.8578 48.3112 27.3838 47.9869 26.036 47.9869C24.621 47.9869 23.1048 48.3112 21.4833 48.964C19.8576 49.621 18.5521 49.9621 17.5497 49.9958C16.0293 50.059 14.5131 49.3893 12.997 47.9827C12.0325 47.1403 10.8238 45.6958 9.375 43.6489C7.82092 41.4631 6.54481 38.9319 5.54666 36.0428C4.48113 32.922 3.94205 29.9023 3.94205 26.9752C3.94205 23.6228 4.66644 20.7337 6.11523 18.312C7.25657 16.3662 8.77274 14.8332 10.668 13.7045C12.5674 12.58 14.6142 12.003 16.8253 11.9651C18.034 11.9651 19.6176 12.34 21.5886 13.0728C23.5512 13.8098 24.8147 14.1846 25.3664 14.1846C25.7791 14.1846 27.1816 13.7466 29.5527 12.8748C31.7975 12.0662 33.6927 11.7335 35.2468 11.8641C39.4542 12.2052 42.6129 13.8603 44.7145 16.8506C40.9535 19.129 39.092 22.3214 39.1299 26.4193C39.1636 29.6117 40.3218 32.265 42.596 34.3708C43.6279 35.3479 44.7776 36.106 46.0579 36.6408C45.78 37.4537 45.4852 38.2244 45.1735 38.9656ZM35.529 1.00236C35.529 3.50404 34.6151 5.83726 32.7957 7.99781C30.5972 10.5669 27.9397 12.0494 25.059 11.8177C25.0211 11.5187 25 11.2028 25 10.8701C25 8.46951 26.0445 5.90044 27.9018 3.79885C28.8283 2.73332 30.0076 1.84889 31.4353 1.14555C32.863 0.45064 34.2107 0.0673855 35.4784 0C35.5121 0.332716 35.529 0.669643 35.529 1.00236Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.1159,
    height: 50,
    fill: "white",
    transform: "translate(3.94205)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.98f4e077fe6d63b0b7cc0924a303e748.svg";
export { ForwardRef as ReactComponent };